import LoadingComponent from "./LoadingComponent"
import React from "react"

export default function ButtonComponent({onClick, title, loading}) {
    return(
        <div className="w-full bg-blue-600 text-white py-2 rounded-md font-semibold hover:bg-blue-700 transition flex w-100 justify-center items-center">
            <button onClick={onClick && !loading ? ()=>onClick() : ()=>undefined} type="submit" className="">
                {title}
            </button>
            {loading && <LoadingComponent className='border-white h-8 w-8'/> }
        </div>
    )
}